<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <district-create-or-update v-model="district" :errors="errors"></district-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
    
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :add-callback="createNew"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
    import { BCard } from 'bootstrap-vue';
    import SystemDataApi from '@/api/system-data';
    import DistrictCreateOrUpdate from './components/DistrictCreateOrUpdate.vue'

    export default {
        components: {
            BCard,
            DistrictCreateOrUpdate
        },
        data() {
            return {
                fields:[
                    {name:'Ülke',key:'CountryName',thClass:'w-33'},
                    {name:'İlçe',key:'Name',thClass:'w-33'},
                    {name:'İl',key:'ProvinceName',thClass:'w-34'},
                ],
                buttons:[
                    { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                    { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                ],
                district: {
                    Id: null,
                    Name: null,
                    X_Coordinate: null,
                    Y_Coordinate: null,
                    PostCode: null,
                    ProvinceId: null,
                    CountryId: null
                },
                errors: {},
                editing: false,
                loading: false
            }
        },
        methods: {
            provider(data) {
                return SystemDataApi.DistrictOperations.Table(data)
            },
            clearForm() {
                this.editing = false
                this.district.Id = null
                this.district.Name = null
                this.district.X_Coordinate = null
                this.district.Y_Coordinate = null
                this.district.PostCode = null
                this.district.ProvinceId = null
                this.district.CountryId = null
            },
            createNew() {
                this.clearForm();
                this.$showModal('create-or-update');
            },
            edit(item){
            this.clearForm()
            this.editing = true
            this.district.Id = item.Id
            this.district.Name = item.Name
            this.district.X_Coordinate = item.X_Coordinate
            this.district.Y_Coordinate = item.Y_Coordinate
            this.district.PostCode = item.PostCode
            this.district.CountryId = item.CountryId
            this.district.ProvinceId = item.ProvinceId
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            SystemDataApi.DistrictOperations.CreateOrUpdate(this.editing,this.district)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli ilçe bilgisini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SystemDataApi.DistrictOperations.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        }
    }
</script>
